"use client";

import { motion, useReducedMotion } from "framer-motion";
import { ReactNode } from "react";

/**
 * Scroll-triggered fade/slide-in. Uses IntersectionObserver (viewport root)
 * so it works regardless of which element is the scroll container.
 */
export default function Reveal({
    children,
    className,
    delay = 0,
    y = 24,
    once = true,
}: {
    children: ReactNode;
    className?: string;
    delay?: number;
    y?: number;
    once?: boolean;
}) {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-60px" }}
            transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
}
